import {PubWebCaseView} from "app/edozvola/cases/cases.model";
import axios from "axios";
import { removeBlankOrNullValues } from 'app/shared/util/common';

export const searchMyCases = async ({ signal, pagination, caseFilter }): Promise<PubWebCaseView> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(
        `api/cases/my-cases?page=${pagination.page}&size=${pagination.size}&column=${pagination.column}&direction=${pagination.direction}&edozvolaFilter=${caseFilter.edozvolaFilter}&earhivaFilter=${caseFilter.earhivaFilter}`,
        removeBlankOrNullValues(caseFilter),
      )
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.error);
      });
  });
};

export const searchParticipantCases = async ({ signal, pagination, caseFilter }): Promise<PubWebCaseView> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(
        `api/cases/case-participants?page=${pagination.page}&size=${pagination.size}&column=${pagination.column}&direction=${pagination.direction}&edozvolaFilter=${caseFilter.edozvolaFilter}&earhivaFilter=${caseFilter.earhivaFilter}`,
        removeBlankOrNullValues(caseFilter),
      )
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.error);
      });
  });
};

export const createCaseAmendment = async (idCase: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/case-amendment/${idCase}/start`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.error))
  })
}

export const fetchCaseInPreviewMode = async (idCase: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${idCase}/preview-mode`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.error))
  })
}
